import axios, { AxiosRequestConfig } from 'axios';
import { useEffect, useState } from 'react';

const useAxiosWLS = <TResponse = any, TBody = any, TError = any>({url, options}:{url?: string, options?: AxiosRequestConfig<any>}): {data: TResponse|undefined, error: Error | undefined, loading: boolean, refetch: Function, isReady: boolean} =>{
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const refetch = async () => {
    if (!url) return;

    setLoading(true);
    try {
      let method = options?.method || 'GET';
      const response = await axios.request<TResponse>({
        url,
        method,
        data: options?.data,
        headers: options?.headers,
      });
      setData(response.data);
      setIsReady(true);
      setError(null);
    } catch (err) {
      setError(err as TError);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!url) return;

    setLoading(true);

    refetch()
  }, [url]);

  return { data, error, loading, refetch, isReady };
}




export default useAxiosWLS